import {UnitSystem} from "@/interfaces/units";
import {DesignScenarioType} from "@/modules/design/interfaces/shared";

export enum BaseScenarioType {
  design = 'DESIGN',
  lcca = 'LCCA',
  agencyCost = 'AGENCYCOST',
  perRoad = 'PERROAD',
  structure = 'STRUCTURE'
}

export interface IBaseScenario {
  name: string,
  id: number | null,
  user: number | null,
  project: number | null,
  created: string,
  modified: string,
  visible: boolean,
  displayUnits: UnitSystem,
  scenarioType: BaseScenarioType,
  isComputedFromLegacy: boolean,
}

export interface IDesignBaseScenario extends IBaseScenario {
  // name: string,
  // project: string
  // created: string,
  // modified: string,
  // visible: boolean,
  // displayUnits: UnitSystem,
  // scenarioType: BaseScenarioType,
  designScenarioType: DesignScenarioType,
  // isComputedFromLegacy: boolean,
}

